import dayjs from "dayjs";

type DurationType = 'hour' | 'day' | 'week';

export const formatDateString = (date:Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const formatPrice = (price: number | undefined | null) => {
    const value = typeof price === "number" ? price : 0;
    return `$${value.toFixed(2)}`;
};

export const parseTime12Hour = (timeStr: string) => {
  const match = timeStr.match(/(\d+):?(\d*)\s*(AM|PM)/i);
  if (!match) return { hours: 0, minutes: 0 };

  let hours = parseInt(match[1], 10);
  const minutes = parseInt(match[2] || "0", 10);
  const period = match[3].toUpperCase();

  if (period === "PM" && hours !== 12) hours += 12;
  if (period === "AM" && hours === 12) hours = 0;

  return { hours, minutes };
};

export const getDurationType = (days: number): DurationType => {
  if (days < 1) return 'hour';
  if (days >= 7 && days % 7 === 0) return 'week';
  return 'day';
};

export const parseTime = (base: dayjs.Dayjs, time: string) => {
  const [h, m] = time.split(':').map(Number);
  return base.clone().hour(h).minute(m).second(0);
};

export const minutesBetween = (start: dayjs.Dayjs, end: dayjs.Dayjs) =>
  end.diff(start, 'minute');
